import React from "react";

import { Col, Row, Label, Alert } from "reactstrap";
import Select from "react-select";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import MySelect from "../test";

import { useSelector } from "react-redux";

const Formulario = (props) => {
  const error = useSelector((state) => state.Casos.error);
  const prueba = useSelector((state) => state.Casos);
  console.log(props);

  return (
    <React.Fragment>
      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label for="tipo_visita" className="form-label mt-2">
            <strong> TIPO DE SERVICIO</strong>
          </Label>
          <Select
            id="tipo_servicio"
            name="tipo_servicio"
            options={props.TipoServicio}
            onChange={props.handleSelectTipoServcio}
            autoFocus
          />

          {error && error.tipo_servicio ? (
            <Alert color="danger" className="mt-2">
              {error.tipo_servicio}
            </Alert>
          ) : null}
        </Col>

        <Col md={6} className="mb-3">
          <Label for="datosServicio" className="form-label mt-2">
            <strong> DATOS DE SERVICIO</strong>
          </Label>
          <textarea
            className="form-control"
            id="datosServicio"
            name="datosServicio"
            type="textarea"
            rows="2"
            value={props.formData.datosServicio}
            onChange={props.onChange}
          />
          {error && error.datosServicio ? (
            <Alert color="danger" className="mt-2">
              {error.datosServicio}
            </Alert>
          ) : null}
        </Col>
      </Row>

      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label
            for="detallesServicio"
            className="col-form-label col-sm-8 d-flex"
          >
            <strong>DETALLES DEL SERVICIO </strong>
          </Label>

          <textarea
            className="form-control"
            id="detallesServicio"
            name="detallesServicio"
            type="textarea"
            rows="4"
            value={props.formData.detallesServicio}
            onChange={props.onChange}
          />

          {error && error.detallesServicio ? (
            <Alert color="danger" className="mt-2">
              {error.detallesServicio}
            </Alert>
          ) : null}
        </Col>

        <Col md={6} className="mb-3">
          <Label for="observaciones" className="col-form-label col-sm-4 d-flex">
            <strong>OBSERVACIONES </strong>
          </Label>

          <textarea
            className="form-control"
            id="observaciones"
            name="observaciones"
            type="textarea"
            rows="4"
            value={props.formData.observaciones}
            onChange={props.onChange}
          />

          {error && error.observaciones ? (
            <Alert color="danger" className="mt-2">
              {error.observaciones}
            </Alert>
          ) : null}
        </Col>
      </Row>

      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label for="image_file" className="col-form-label col-sm-4 d-flex">
            <strong>IMAGENES (OPCIONAL)</strong>
          </Label>

          <input
            className="form-control"
            id="image_file"
            name="image_file"
            type="file"
            onChange={(e) => props.handleImageChange(e.target.files)}
          />

          {Array.isArray(error.images) ? (
            <Alert color="danger" className="mt-2">
              {error.images[0].image}
            </Alert>
          ) : null}
        </Col>

        <Col md={6} className="mb-3">
          <Label for="grupo_tecnico" className="col-form-label col-sm-4 d-flex">
            <strong>GRUPO DE TECNICOS</strong>
          </Label>

          <Select
            id="grupo_tecnico"
            name="grupo_tecnico"
            placeholder="Seleccione"
            onChange={props.handleSelectGrupoTecnico}
            options={
              Array.isArray(props.grupotTecnico)
                ? props.grupotTecnico.map((item) => ({
                    label: item.nombre,
                    value: item.id,
                  }))
                : []
            }
          />
        </Col>
      </Row>

      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-4 d-flex"
          >
            <strong>ASIGNADO A</strong>
          </Label>
            {Array.isArray(props.sd) && props.sd.length > 0 ?
            
            
            
          <MySelect
            id="tecnico_asignado"
            name="tecnico_asignado"
            placeholder="Seleccione"
            isMulti
            allowSelectAll
            options={
              props.sd &&
              props.sd.map((item) => ({
                label: item.get_full_name,
                value: item.id,
              }))
            }
            onChange={(item) =>
              props.setFormData({
                ...props.formData,
                tecnico_asignado: item && item.map((item) => item.value),
              })
            }
          />
            : (null)}
        </Col>

        <Col md={6} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-8 d-flex"
          >
            <strong>FECHA PARA ASIGNAR</strong>
          </Label>

          <input
            className="form-control d-block"
            placeholder="Fecha"
            onChange={(e) => props.onChangeFecha(e)}
            type="date"
          />
        </Col>
      </Row>

      <Row className="col-lg-12 justify-content-center ">
        <Col md={6} className="mb-3">
          <Label for="horaentrada" className="col-form-label col-sm-8 d-flex">
            <strong>HORA DE ENTRADA</strong>
          </Label>

          <Flatpickr
            className="form-control d-block"
            placeholder="Hora de Entrada"
            onInput={props.onChangeHoraEntrada}
            options={{
              enableTime: true,

              noCalendar: true,

              dateFormat: "H:i K",
              minuteIncrement: "15",
            }}
          />
        </Col>

        <Col md={6} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-6 d-flex"
          >
            <strong>HORA DE SALIDA</strong>
          </Label>

          <Flatpickr
            className="form-control d-block"
            placeholder="Hora de Salida"
            onInput={props.onChangeHoraSalida}
            options={{
              enableTime: true,

              noCalendar: true,

              dateFormat: "H:i K",
              minuteIncrement: "15",
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Formulario;
